import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import useLicenseSx from '../hooks/useLicenseSx';
import { LICENSE_STATUS_TABS } from '../utils/licenseConstants';

const TAB_EMPTY_MESSAGES = {
  active: {
    title: 'No active licenses',
    description: 'Publish a draft license or create a new active plan for organisation assignment.',
  },
  draft: {
    title: 'No draft licenses',
    description: 'Draft plans can be prepared and reviewed before making them active.',
  },
  archived: {
    title: 'No archived licenses',
    description: 'Archived plans remain for history but are not available for new assignments.',
  },
};

function getTabLabel(statusTab) {
  return LICENSE_STATUS_TABS.find((tab) => tab.value === statusTab)?.label?.toLowerCase() ?? statusTab;
}

export default function LicenseEmptyState({
  onCreate,
  isSearching,
  statusTab = 'active',
}) {
  const styles = useLicenseSx();
  const tabMessages = TAB_EMPTY_MESSAGES[statusTab] ?? TAB_EMPTY_MESSAGES.active;

  return (
    <Box sx={styles.emptyState}>
      <Box sx={styles.emptyIcon}>
        <VerifiedUserOutlinedIcon fontSize="large" />
      </Box>
      <Typography variant="h6" fontWeight={700} gutterBottom>
        {isSearching
          ? `No ${getTabLabel(statusTab)} licenses found`
          : tabMessages.title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420, mb: 3 }}>
        {isSearching
          ? 'Try a different search term or switch to another status tab.'
          : tabMessages.description}
      </Typography>
      {!isSearching && statusTab !== 'archived' && (
        <Button variant="contained" onClick={onCreate} sx={styles.createButton}>
          Create License
        </Button>
      )}
    </Box>
  );
}
